import React from 'react';
import { ImageTitle } from '../../core/ImageTitle';
import { ApiDataAccess } from '../../infrastructure/ApiDataAccess';

export class StandardProductHealthView extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            errors: [],
            loadError: null
        };

        this.apiDataAccess = new ApiDataAccess('data/standard-product/health');
    }

    componentDidMount() {
        this.loadHealth();
    }

    async loadHealth() {
        this.apiDataAccess.get('')
            .then(response => {
                this.setState({
                    errors: response.errors || [],
                    loading: false
                });
            })
            .catch(ex => {
                this.setState({
                    loadError: 'Error on HTTP GET call',
                    loading: false
                });
            })
    }

    render() {
        const { loading, errors, loadError } = this.state;

        return (
            <div className="view container mt-4">
                <ImageTitle text="Standard Product Health" />

                <div className="card-body">

                    {loading && (
                        <div className="d-flex align-items-center text-info">
                            <span className="spinner-border spinner-border-sm me-2" />
                            <strong>Loading health status…</strong>
                        </div>
                    )}

                    {loadError && (
                        <div className="alert alert-danger mb-0">
                            <strong>❌ Failed to load health data</strong>
                            <div className="small mt-1">{loadError}</div>
                        </div>
                    )}

                    {!loading && !loadError && errors.length === 0 && (
                        <div className="alert alert-success mb-0">
                            <strong>✅ System Healthy</strong>
                        </div>
                    )}

                    {!loading && errors.length > 0 && (
                        <div className="alert alert-danger mb-0">
                            <strong>⚠️ Issues Detected</strong>
                            <ul className="list-group list-group-flush mt-2">
                                {errors.map((error, index) => (
                                    <li
                                        key={index}
                                        className="list-group-item text-danger px-0"
                                    >
                                        {error}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                </div>
            </div>
        );
    }

}
